import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { SystemApiClient } from "../clients/system-api/SystemApiClientp";
import { AddConfigurationData, AddWorkingHoursDailyConfigs, AdministrationResultStatus, ConfigurationParameterDataAdministrationResult, UpdateConfigurationData, WorkingHoursDailyConfigData } from "../clients/system-api/SystemApiClient";

@Injectable({
    providedIn: 'root'
  })
  export class ConfigurationParameterService {
    constructor (private systemApiClient: SystemApiClient) { }

    addConfiguration(addConfigurationData: AddConfigurationData): Observable<AdministrationResultStatus>{
      return this.systemApiClient.addConfiguration(addConfigurationData);
    }

    updateConfiguration(updateConfigData: UpdateConfigurationData): Observable<AdministrationResultStatus>{
      return this.systemApiClient.updateConfiguration(updateConfigData);
    }

    updateWorkingHoursDailyConfig(dailyConfig: WorkingHoursDailyConfigData): Observable<AdministrationResultStatus>{
      return this.systemApiClient.updateWorkingHoursDailyConfig(dailyConfig);
    }

    updateAllWorkingHoursDailyConfigs(workingHours: AddWorkingHoursDailyConfigs): Observable<AdministrationResultStatus>{
      return this.systemApiClient.updateAllWorkingHoursDailyConfigs(workingHours);
    }

    retrieveActiveConfigurationParameter(): Observable<ConfigurationParameterDataAdministrationResult>{
        return this.systemApiClient.retrieveActiveConfigurationParameter();
    }
    
}